import React from 'react';

import { useWebRTCProtocol } from 'hooks/useWebRTCProtocol';

import { WebRTCPlayerWhep } from './WebRTCPlayerWhep';
import { WebRTCPlayerLegacy } from './WebRTCPlayerLegacy';
import { BasePlayerProps } from './types';

/** Tracks streams whose gateways don't support WHEP. Resets on page refresh. */
const whepUnsupportedStreams = new Set<string>();

export function WebRTCPlayer({ className, streamID, auto }: BasePlayerProps) {
  const { protocol: manualProtocol } = useWebRTCProtocol();
  const [whepUnsupported, setWhepUnsupported] = React.useState(
    () => whepUnsupportedStreams.has(streamID)
  );
  const handleWhepUnsupported = React.useCallback(() => {
    whepUnsupportedStreams.add(streamID);
    setWhepUnsupported(true);
  }, [streamID]);

  const protocol = React.useMemo(() => {
    if (manualProtocol === 'whep' || manualProtocol === 'legacy') {
      return manualProtocol;
    }
    // Auto mode: try WHEP first, fall back to legacy if unsupported
    return whepUnsupported ? 'legacy' : 'whep';
  }, [manualProtocol, whepUnsupported]);

  if (protocol === 'whep') {
    return (
      <WebRTCPlayerWhep
        className={className}
        streamID={streamID}
        auto={auto}
        onWhepUnsupported={handleWhepUnsupported}
      />
    );
  }

  return (
    <WebRTCPlayerLegacy
      className={className}
      streamID={streamID}
      auto={auto}
    />
  );
}

export default WebRTCPlayer;
